import React from 'react'
import ReactDOM from 'react-dom'
import { AppContainer } from './containers/AppContainer/AppContainer'

ReactDOM.render(<AppContainer />, document.getElementById('root'))